angular.module('lf.desktop')

.directive('videoPlayer', function ($parse, gtmService) {
  return function (scope, el, attrs) {
    var options = $parse(attrs.videoPlayer)(scope) || {};
    var player;
    var id = 'video-player-' + Date.now() + (Math.random() * 1e5 | 0);

    var msie = parseInt((/msie (\d+)/.exec(navigator.userAgent.toLowerCase()) || [])[1]);
    if (isNaN(msie)) { // IE11 check
      msie = parseInt((/trident\/.*; rv:(\d+)/.exec(navigator.userAgent.toLowerCase()) || [])[1]);
    }
    var mode = (msie || lf.data.xhr.client.isLFC) ? 'flash' : 'html5';
    
    if (!options.url) {
      throw new Error('videoPlayer directive: `url` key is required');
    }
    
    var $container = $('<div></div>');
    $container.attr('id', id);
    el.prepend($container);
    
    var defaults = {
      width: 480,
      height: 270,
      primary: mode,
      autoInit: true,
      autoPlay: false,
      aboutText: '',
      aboutLink: '',
      skin: 'glow'
    }
    
    var opts = $.extend({}, defaults, options);

    var videoUrl = opts.url;
    if (videoUrl.slice(0, 2) === '//') {
      var protocol = document.location.protocol === 'https:' ? 'https:' : 'http:';
      videoUrl = protocol + videoUrl;
    }

    function initVideoPlayer () {
      jwplayer(id).setup({
        file: videoUrl,
        image: opts.image,
        width: opts.width,
        height: opts.height,
        primary: opts.primary,
        skin: opts.skin,
        abouttext: opts.aboutText,
        aboutlink: opts.aboutLink,
        events: {
          onReady: function () {
            if (opts.autoPlay) {
              this.play();
            }
          }
        }
      });
      
        // GTM tracking
      jwplayer(id)
        .onPlay(gtmTrackVideoActivity.bind(null, 'Play'))
        .onPause(gtmTrackVideoActivity.bind(null, 'Pause'))
        .onComplete(gtmTrackVideoActivity.bind(null, 'Complete'))
        .onError(gtmTrackVideoActivity.bind(null, 'Error'));

      player = jwplayer.api.playerById(id);
    }
    
    if (opts.autoInit) {
      setTimeout(initVideoPlayer, 0);
    }
    
    function gtmTrackVideoActivity (action) {
      gtmService.pushVideoActivity({
        action: action,
        url: videoUrl,
        prodId: opts.productId
      });
    }

    function destroyVideoPlayer () {
      if (!player) return;
      player.stop();
      player.remove();
    }

    scope.$on('$destroy', function onDestroy () {
      destroyVideoPlayer();
    });
  }
});
